import { create } from 'zustand';

/**
 * Thin mirror of MSAL's active-account state. The source of truth lives in
 * MSAL; this store exists so React components outside the MsalProvider tree
 * can read authenticated state without prop drilling. Kept deliberately thin:
 * username only, plus a flag for "MSAL initialized and account loaded".
 */
interface AuthStoreState {
  accountId: string | null;
  username: string | null;
  displayName: string | null;
  isReady: boolean;
  setAccount: (a: { accountId: string; username: string; displayName: string | null } | null) => void;
  setReady: (ready: boolean) => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  accountId: null,
  username: null,
  displayName: null,
  isReady: false,
  setAccount: (a) => set(a
    ? { accountId: a.accountId, username: a.username, displayName: a.displayName }
    : { accountId: null, username: null, displayName: null }),
  setReady: (ready) => set({ isReady: ready })
}));
